import type { RootState } from "../store";

export function selectUnreadNotificationCount(state: RootState) {
  return state.notifications?.notifications?.filter(notification => !notification.read_at).length || 0;
}
